import React from 'react'
import { Button, Tooltip } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

type Props = {
  onSubmit: () => void
  isLoading: boolean
}

export const View: React.FunctionComponent<Props> = ({
  onSubmit,
  isLoading,
}) => {
  return (
    <>
      <Tooltip title="Скачать счет на оплату">
        <Button
          shape="circle"
          icon={<DownloadOutlined />}
          loading={isLoading}
          onClick={onSubmit}
        />
      </Tooltip>
    </>
  )
}
